// @ts-nocheck
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, SetCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

// Starter Custom Code
import { checkoutOption, dispatchCheckoutEvent } from "@store/Framework/Services/AnalyticsService";

replaceInChain(chain, SetCart, props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart and we are trying to use it to set initial values");
    }

    dispatchCheckoutEvent(1, checkoutOption.shippingAddress, cart); // Starter Custom Code

    props.cart = cart;
});
